import dayjs from "dayjs";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import { i18nFilter } from "app/filters/i18nFilter";
import { getDefaultParamsForState } from "app/pages/digital-suite/home-page/helpers";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import { createExampleKeywordsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { useKeywordGroups } from "app/services/keyword-groups";

export const AnalyzeKeywordListStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();
    const userGroups = useKeywordGroups();

    const analyzeKeywordList = async (): Promise<void> => {
        let keywordsListId: string;
        userGroups.data.sort((a, b) => {
            const aDate = dayjs(a.AddedTime);
            const bDate = dayjs(b.AddedTime);
            return aDate.isAfter(bDate) ? -1 : 1;
        });

        if (userGroups.data.length) {
            keywordsListId = userGroups.data[0].Id;
        } else {
            keywordsListId = await createExampleKeywordsList();
        }

        props.onStepComplete("growth.homepage.wizard.button.analyzeKeywordList");
        proNavigator.go("organicsearch_keywordAnalysis_overview_2", {
            ...getDefaultParamsForState("organicsearch_keywordAnalysis_overview_2"),
            keyword: `*${keywordsListId}`,
        });
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.analyze_keyword_list.title")}
            description={i18n("growth.homepage.activationWizard.step.analyze_keyword_list.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.analyze_keyword_list.button"),
                            onClick: analyzeKeywordList,
                            type: "primary",
                        },
                    ]}
                />
            }
        />
    );
};
